import { BankConnection, Company, Expense, Mileage } from "@finway-group/shared/lib/models"
import { BankSubjectOptionEnum } from "@finway-group/shared/lib/models/company/bankSubjectOption.enum"
import { flatten, stripForBankSubjectLine, stripForSEPASubjectLine } from "./helper.utils"

export const buildBankSubjectLine = (bankSubjectParts: Company["customBankSubjectParts"], expense: Expense) =>
    stripForBankSubjectLine(buildRawBankSubjectLine(bankSubjectParts, expense))

export const buildSEPASubjectLine = (bankSubjectParts: Company["customBankSubjectParts"], expense: Expense) =>
    stripForSEPASubjectLine(buildRawBankSubjectLine(bankSubjectParts, expense))

export const buildRawBankSubjectLine = (bankSubjectParts: Company["customBankSubjectParts"], expense: Expense) =>
    (bankSubjectParts ?? [])
        .map((subjectPart) => {
            switch (subjectPart.part) {
                case BankSubjectOptionEnum.DESCRIPTION:
                    return expense.description || (expense as Mileage)?.tripReason || "-"
                case BankSubjectOptionEnum.EXPENSE_NUMBER:
                    return `Expense Nr. ${expense.expenseNumber}`
                case BankSubjectOptionEnum.INVOICE_NUMBER:
                    return expense.invoiceNumber ?? "-"
                case BankSubjectOptionEnum.REQUEST_ITEMS:
                    // TODO: what do do here exactly?
                    return expense.splits.map((split: any) => split.name)
                case BankSubjectOptionEnum.VENDOR_NAME:
                    return expense.getCreditor()?.name
                default:
                    return ""
            }
        })
        .join(", ")

export const getActiveAccounts = (bankConnections: Array<BankConnection>) =>
    flatten(
        bankConnections.map((con) =>
            con.accounts.filter((account) => !account.deleted).map((account) => ({ ...account, bank: con.bankName, isDefault: con.isDefault && account.isDefault })),
        ),
    )
